import classNames from 'classnames';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';

import Icon from '@utilities/icon';
import { colors } from '@configs/Theme';
import { routeList } from '@routes/routeList';

type SearchBoxProps = {
  placeholder: string;
  queries?: ParsedUrlQuery;
  className?: string;
};

const SearchBox = ({ placeholder, queries, className }: SearchBoxProps) => {
  const { push } = useRouter();

  return (
    <div className={classNames(className, 'px-4 py-2')}>
      <div
        className="h-10 w-full rounded-full px-4 flex items-center gap-x-2 bg-surface-tertiary text-content-tertiary text-Label/Small"
        onClick={() =>
          push({
            pathname: routeList?.shopSearch,
            query: { ...queries },
          })
        }
        tabIndex={0}
        role="button"
        onKeyDown={() => {
          return;
        }}
      >
        <Icon
          name="Magnifier"
          width={1.25}
          height={1.25}
          fill={colors?.gray[600]}
        />

        <span>{placeholder}</span>
      </div>
    </div>
  );
};

export default SearchBox;
